// extracted by mini-css-extract-plugin
module.exports = {"card":"ProjectCard_card__36SlQ","header":"ProjectCard_header__1XS30","body":"ProjectCard_body__1azdI"};